<!-- erroe page for other error message  -->
<div *ngIf="errorCode == 'INVALID_VERIFICATION_TOKEN'">
    <div class="inner-container-wrapper">
        <div class="titletext">
            {{sessionStatus}}
        </div>
        <!-- <p class="peratext pt48"> Help us improve your experience by sending an error report </p> -->
        <div class="pt48">
            <button class="cp-btn cp-btn-primary" (click)="helperService.goToForgotPasswordPage()">Restore Password</button>
        </div>
    </div>
</div>
<!-- erroe page for other error message  -->
<div *ngIf="errorCode == 'SESSION_EXPIRED'">
    <div class="inner-container-wrapper">
        <div class="titletext no-center">
            {{'RESET_PASSWORD.SESSION_EXPIRED' | translate}}
        </div>
        <p class="peratext-light no-center pt16"> {{'RESET_PASSWORD.SESSION_EXPIRED_MSG' | translate}}  </p>
        
    </div>

    
</div>

<!-- error page for blocked user (failed OTP ) -->
<div *ngIf="errorCode == 'ACCOUNT_BLOCKED_FAILED_OTP_ATTEMPTS'">
    <div class="inner-container-wrapper">
        <div class="titletext no-center">
            Account is blocked 
        </div>
        <p class="peratext no-center pt16"> Your account has been blocked as OTP verification has failed 5 times. </p>
        <p class="peratext no-center pt16"> Please contact <a href="javascript:;" (click)="helperService.goToSupportPage()"> customer support </a>for assistance. Customer Support via phone available 24/7
        </p>
        <p class="peratext no-center pt16"> +370 666 44600 <span class="border-right"></span>  +356 279 22875</p>  
        <div class="pt48">
            <button class="cp-btn cp-btn-primary" (click)="helperService.goToSupportPage()">Contact support</button>
        </div>
    </div>
</div>

<!-- error page for blocked user (failed OTP ) -->
<div *ngIf="errorCode == '02301036' || errorCode == '02301035' || errorCode == '02301043'" >
    <div class="inner-container-wrapper">
        <div class="titletext no-center">
            Account is blocked 
        </div>
        <p class="peratext no-center pt16"> Your account has been blocked as OTP verification has failed 5 times. </p>
        <p class="peratext no-center pt16"> Please contact <a href="javascript:;" (click)="helperService.goToSupportPage()"> customer support </a>for assistance. Customer Support via phone available 24/7
        </p>
        <p class="peratext no-center pt16"> +370 666 44600 <span class="border-right"></span>  +356 279 22875</p>  
        <div class="pt48">
            <button class="cp-btn cp-btn-primary" (click)="helperService.goToSupportPage()">Back to login</button>
        </div>
    </div>
</div>

<!-- error page for blocked user -->
<div *ngIf="errorCode == 'ACCOUNT_BLOCKED'">
    <div class="inner-container-wrapper">
        <div class="titletext no-center">
            Account is blocked 
        </div>
        <!-- <p class="peratext no-center pt16"> Your account has been blocked as OTP verification has failed 5 times. </p> -->
        <p class="peratext no-center pt16"> Please contact <a href="javascript:;" (click)="helperService.goToSupportPage()"> customer support </a>for assistance. Customer Support via phone available 24/7
        </p>
        <p class="peratext no-center pt16"> +370 666 44600 <span class="border-right"></span>  +356 279 22875</p>  
        <div class="pt48">
            <button class="cp-btn cp-btn-primary" (click)="helperService.goToSupportPage()">Contact support</button>
        </div>
    </div>
</div>